var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import './App.css';
import { ThemeProvider } from '@mui/material/styles';
import defaultTheme from './theme/theme'; // Import the theme file
import { AppRouter } from './router/AppRouter';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext'; // Import the AuthProvider
function App() {
    return (_jsx(ThemeProvider, __assign({ theme: defaultTheme }, { children: _jsx(BrowserRouter, { children: _jsx("div", __assign({ style: { minHeight: "100vh", display: "flex", flexDirection: "column" } }, { children: _jsx(AuthProvider, { children: _jsx(AppRouter, {}) }) })) }) })));
}
export default App;
